export default __webpack_public_path__ + "images/csv-file.svg";